let required;
let validInputField = true;
let inputField=`<label for="deine-pragung" style="margin-right:20px;" >Dein Text (max 25 Zeichen): </label><br>
<input onchange="changepreagung(this, event)" onkeydown="changepreagung(this, event)" onkeyup="changepreagung(this, event)" minlength="0" maxlength="25" {% if product.selected_variant.id == 40288049070286  %} required="true" {% endif %} id="deine-pragung" type="text" name="properties[Deine Prägung]" placeholder="Max Mustermann"><br>
<i>*Leider können wir bestimmte Sonderzeichen wie Smileys nicht prägen</i><br>
                <i style="color:red">Prägung erhöht die Lieferzeit um 5-7 Tage</i>`;
function praegung(obj, event){
  if(event.target.value == 40288049070286){
    required = true;
  	document.getElementById('mit-praegung').innerHTML = inputField;
  	document.getElementById('deine-pragung').required = "true";
  }else{
    required = false;
  	document.getElementById('deine-pragung').removeAttribute('required');
  	document.getElementById('deine-pragung').value = "";
  	document.getElementById('mit-praegung').innerHTML = '';
  }
  document.getElementById('mit-praegung').style.display = (event.target.value == 40288049070286) ? 'block' : 'none';
  validateForm();
}


function copyToClipboard(obj, toCopy){
  /* Get the text field */
  var copyText = document.getElementById("copy-clipboard");
      copyText.value = toCopy;
      copyText.select();
      copyText.setSelectionRange(0, 99999); 
  
  navigator.clipboard.writeText(toCopy);
  obj.children[0].innerHTML = 'Link kopiert!';
}

function changepreagung(obj, event){
  obj.value = obj.value.replace(/((?![\s0-9a-zA-ZäüöÄÜÖß\-\.\,\:\!\"\%\&\/\(\)\=\?\+]).)*/gi, '');
  validateForm();
}


function validateForm(){
  if(document.getElementById('deine-pragung') && document.getElementById('mit-praegung').style.display === 'block'){
    let inputValue = document.getElementById('deine-pragung').value;
    console.log(inputValue);
    if(!inputValue || inputValue.length < 1){
      validInputField = false;
    }else{
      validInputField = true;
    }
  }else{
  	validInputField = true;
  }
}

window.onmousemove = () => {
	startVideo();
}
window.ontouchstart = () => {
	startVideo();
	checkSlideshowMode();
}
window.onload = () => {
	checkSlideshowMode();
}
window.onclick = () => {
	checkSlideshowMode();
}
window.onresize = () => {
	checkSlideshowMode();
}
  
function startVideo() {
  try{
	document.getElementById("video-test").querySelector('video').play();
    document.getElementById("banner_video").querySelector('video').play();
  }catch(e){
    
  }
}
let customSlideShow;
let slideshowaspect = [];
let slidingWindow = 0;
let slidingValue = 0;
let slidingWidth = window.innerWidth;
let slideControl;
let aspectRatio;
function checkSlideshowMode(){
  let screenAspect = window.innerWidth/window.innerHeight;
  customSlideShow = document.querySelector('.custom-slideshow');
  aspectRatio = screenAspect > 1 ? 'landscape' : 'portrait';
  slideshowaspect = customSlideShow.querySelectorAll('div[data-slideshow-aspect-ratio="'+aspectRatio+'"]');
  if(customSlideShow.id === 'allow-landscape' && aspectRatio == 'landscape'){
  slideshowaspect = customSlideShow.querySelectorAll('div[data-slideshow-aspect-ratio]');
  }
  let allSlideshows = customSlideShow.querySelectorAll('div[data-slideshow-aspect-ratio]');
  customSlideShow.style.width = (slideshowaspect.length * window.innerWidth)+'px';
  for(let entry of allSlideshows){
  	entry.style.display = 'none';
  }
  slideControl = document.querySelector('.slide-control');
  slideControl.innerHTML = '';
    let index = 0;
    for(let entry of slideshowaspect){
      entry.style.display = 'block';
      let div = document.createElement('DIV');
      div.className = 'slide-control-button';
      div.setAttribute('onclick', 'changeSlide('+index+')');
      slideControl.append(div);
      index++;
    }
  
    slideControl.style.marginLeft = -(slideshowaspect.length*10)+'px';
  
  if(aspectRatio === 'landscape'){
    slideControl.style.display = 'block';
  }else{
    slideControl.style.display = 'none';
  }
  slidingWidth = window.innerWidth;
  changeSlide(slidingWindow);
  customSlideShow.style.visibility = 'visible';

}
function resetLittleSlideShow(){
} 
let oldIndex = slidingWindow;
function changeSlide(index){
  index = +index;
  console.log(index);
  customSlideShow.style.left = -1*(index*window.innerWidth)+'px';
  if(oldIndex != -1){
    slideControl.querySelectorAll('.slide-control-button')[oldIndex].style.background = '#fff';
  }
  slideControl.querySelectorAll('.slide-control-button')[index].style.background = '#ccc';
  slidingWindow = index;
  oldIndex = index;
}
function nextSlide(){
  if(slidingWindow+1 >= slideshowaspect.length ){
  slidingWindow = -1;
  }
  slidingWindow++;
  changeSlide(slidingWindow);
}
function prevSlide(){
  if(slidingWindow-1 < 0 ){
  slidingWindow = slideshowaspect.length-1;
  }
  slidingWindow--;
  changeSlide(slidingWindow);
}